import { defineModule } from '@/core/define';
import { overridable } from '@/core/template-engine';

export default defineModule({
    id: 'promotion',
    routes: [
        {
            path: '/promotion',
            name: 'promotion',
            meta: { requiresAuth: true },
            component: overridable('PromotionPage', () => import(/* webpackChunkName: "promotion" */ './views/PromotionPage.vue'))
        }
    ],
    contributes: {
        'sidebar.menu': [
            { key: 'promotion', order: 20, icon: 'images/menu/promotion.png', to: '/promotion', mobileHidden: true }
        ],
        'bottom.nav': [
            { key: 'promotion', order: 10, icon: 'images/icons/nav-promotion.png', to: '/promotion' }
        ],
        'home.shortcuts': [
            { key: 'reward', order: 30, icon: 'images/icons/shortcut-reward.png', to: '/promotion' }
        ],
        'home.sections': [
            { key: 'promotion', order: 30, component: overridable('PromotionSection', () => import(/* webpackChunkName: "home" */ './components/PromotionSection.vue')) }
        ]
    }
});
